import React, { useEffect } from "react";


import BannerSection from '../../shared/components/BannerSection/BannerSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import SectionInfo from '../../shared/components/SectionInfo/SectionInfo';
import SubscriptionPlan from "../../shared/components/SubscriptionPlan/SubscriptionPlan";


import priceBannerImg from '../../utils/assets/price/protect-your-personal-information.png';
import profilesLockImg from '../../utils/assets/price/unlock-your-personal-information.png';




const Price = props => {
     const bannerSectionInfo =
     {
        cardTitle: "Protect your personal information at the best price",
        cardButtonText: "Start Now",
        lengendBackground: priceBannerImg
     }


     const subscriptionInformation = [
        {       
            subscriptionType: "MONTH",
            subscriptionPrice: "44.99",
            subscriptionTrialInfo: "Trial for 24 days at",
            subscriptionTrialPrice : "3.49",
            subscriptionDescription: "Monthly",
            subscriptionButtonText: "Buy"
        }, 
        {
            
            title : "Join and start improving your privacy and digital security.",
            img: profilesLockImg,
            imgDescription: "profile-lock",
        }
    ]

    useEffect(()=>{
        window.scroll(0,0);
    })

    return ( 
        <React.Fragment>
             <BannerSection props={bannerSectionInfo}/>
             <NavegationInfo page="price"/>
             <SectionInfo title={"Access to the best identity protection"} color={'#0378a6'} />
             <SubscriptionPlan props={subscriptionInformation}/>
        </React.Fragment>
    );            
};

export default Price;